import { APP_NAME, COMPANY_BRAND_NAME } from '../../support/brand';
import { COMPANY_CNPJ, COMPANY_NAME, COMPANY_EMAIL } from '../../support/legal';
import { PANEL_URL } from '../../support/publicUrls';
import { SAME_AS_LINKS } from '../../support/social';
import {
  FAQS,
  LANDING_MARKDOWN_URL,
  LANDING_URL,
  LAST_MODIFIED,
  SEO,
} from './content';

export const SOCIAL_IMAGE_URL = `${PANEL_URL}/images/social/maia-whatsapp.png`;
const SOCIAL_IMAGE_ALT = 'MAIA — inteligência artificial para WhatsApp';

export const META_TAGS = [
  ['meta', { name: 'description', content: SEO.description }],
  [
    'meta',
    { name: 'robots', content: 'index, follow, max-snippet:-1, max-image-preview:large' },
  ],
  ['meta', { property: 'og:type', content: 'website' }],
  ['meta', { property: 'og:locale', content: 'pt_BR' }],
  ['meta', { property: 'og:title', content: SEO.title }],
  ['meta', { property: 'og:description', content: SEO.description }],
  ['meta', { property: 'og:url', content: SEO.canonical }],
  ['meta', { property: 'og:image', content: SOCIAL_IMAGE_URL }],
  ['meta', { property: 'og:image:width', content: '1200' }],
  ['meta', { property: 'og:image:height', content: '630' }],
  ['meta', { property: 'og:image:alt', content: SOCIAL_IMAGE_ALT }],
  ['meta', { name: 'twitter:card', content: 'summary_large_image' }],
  ['meta', { name: 'twitter:title', content: SEO.title }],
  ['meta', { name: 'twitter:description', content: SEO.description }],
  ['meta', { name: 'twitter:image', content: SOCIAL_IMAGE_URL }],
  ['meta', { name: 'twitter:image:alt', content: SOCIAL_IMAGE_ALT }],
  ['link', { rel: 'canonical', href: SEO.canonical }],
  ['link', { rel: 'alternate', type: 'text/markdown', href: LANDING_MARKDOWN_URL }],
];

export const STRUCTURED_DATA = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://okmaia.com/#organization',
    name: COMPANY_BRAND_NAME,
    legalName: COMPANY_NAME,
    taxID: COMPANY_CNPJ,
    url: 'https://okmaia.com/',
    logo: 'https://okmaia.com/logo.png',
    sameAs: SAME_AS_LINKS,
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'sales',
      email: COMPANY_EMAIL,
      url: 'https://wa.me/5521971792112',
      availableLanguage: 'pt-BR',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: COMPANY_BRAND_NAME,
    url: 'https://okmaia.com/',
    inLanguage: 'pt-BR',
    dateModified: LAST_MODIFIED,
    publisher: {
      '@id': 'https://okmaia.com/#organization',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: SEO.title,
    description: SEO.description,
    url: LANDING_URL,
    inLanguage: 'pt-BR',
    dateModified: LAST_MODIFIED,
    about: {
      '@type': 'Thing',
      name: 'Inteligência artificial para WhatsApp',
    },
    publisher: {
      '@id': 'https://okmaia.com/#organization',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: APP_NAME,
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    description: SEO.applicationDescription,
    url: LANDING_URL,
    provider: {
      '@id': 'https://okmaia.com/#organization',
    },
    featureList: [
      'IA para WhatsApp',
      'Conversas com inteligência artificial',
      'Agentes de IA para WhatsApp',
      'Base de conhecimento',
      'Qualificação de contatos',
      'Integrações e tarefas',
      'Transferência para atendimento humano',
    ],
    dateModified: LAST_MODIFIED,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQS.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
    dateModified: LAST_MODIFIED,
  },
];

function escapeAttribute(value) {
  return String(value).replaceAll('&', '&amp;').replaceAll('"', '&quot;');
}

export function renderWhatsAppHeadTags() {
  const tags = META_TAGS.map(([tagName, attributes]) => {
    const serialized = Object.entries(attributes)
      .map(([key, value]) => `${key}="${escapeAttribute(value)}"`)
      .join(' ');
    return `<${tagName} data-whatsapp-static="true" ${serialized}>`;
  });

  tags.push(
    `<script data-whatsapp-static="true" type="application/ld+json">${JSON.stringify(
      STRUCTURED_DATA
    ).replaceAll('<', '\\u003c')}</script>`
  );

  return tags.join('\n    ');
}
